import {
  Button,
  createStyles,
  makeStyles,
  Theme,
  Tooltip,
} from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import React, { useContext, useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { EadSimple, EadTree } from './context/ead-context';
import { GridRootUrl, HierarchyContext } from './context/hierarchy-context';
import { isSame } from './context/utils/ead-tree-context-utils';
import ArrowBack from '@material-ui/icons/ArrowBack';
import AutoSizer from 'react-virtualized-auto-sizer';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    smallExpandButton: {
      minWidth: 25,
      maxWidth: 25,
      height: 20,
      padding: 2,
      margin: '0 8px 0 0',
      color: theme.palette.primary.light,
      borderColor: theme.palette.primary.light,
      '&:hover': {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
      },
    },
    expandButtonContent: {
      '&: media-screen (max-width: 600px)': {
        display: 'none',
      },
    },
    expandButton: {
      minWidth: 40,
      marginRight: 8,
      color: '#a3a3a3',
      borderColor: '#a3a3a3',
      '&:hover': {
        border: '1px solid white',
        color: 'white',
      },
      '&:disabled': {
        border: '1px dashed grey',
        borderColor: 'grey',
        color: 'grey',
        '&:hover': {
          cursor: 'not-allowed',
        },
      },
    },
    tooltip: {
      fontSize: 12,
    },
  })
);

const ControlButtons = () => {
  const { collapseAll, expandNext, flatEad } = useContext(EadTree);
  const classes = useStyles();
  const { push } = useHistory();
  const { rootUrl, getRootId, eadId } = useContext(HierarchyContext);

  const currentIndex = useMemo(
    () =>
      flatEad?.findIndex((n) =>
        isSame(n, { id: eadId, baseIdentifier: eadId } as EadSimple)
      ),
    [flatEad, eadId]
  );

  const searchParams = new URLSearchParams(window.location.search);
  const originatorId = searchParams.get('originator') ?? undefined;

  const originatorParam = `${
    originatorId ? `?originator=${originatorId}` : ''
  }`;

  const linkBack = `${rootUrl}/${getRootId?.()}${originatorParam}`;

  return (
    <div
      style={{
        display: 'flex',
        padding: 8,
        height: 60,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <AutoSizer disableHeight style={{ width: '100%' }}>
        {({ width }: { width: number }) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to={linkBack}>
              <Tooltip
                title={
                  <span className={classes.tooltip}>
                    Zpět na{' '}
                    {rootUrl === GridRootUrl.COLLECTIONS ? 'fondy' : 'pomůcky'}
                  </span>
                }
                placement="top"
              >
                <Button
                  size="small"
                  variant="outlined"
                  className={classes.expandButton}
                >
                  <>
                    {width < 350 ? (
                      <ArrowBack fontSize="small" />
                    ) : (
                      <>
                        Zpět na{' '}
                        {rootUrl === GridRootUrl.COLLECTIONS
                          ? 'fondy'
                          : 'pomůcky'}
                      </>
                    )}{' '}
                  </>
                </Button>
              </Tooltip>
            </Link>
            <Tooltip
              title={<span className={classes.tooltip}>Sbalit vše</span>}
              placement="top"
            >
              <Button
                //disabled={!collapsable}
                variant="outlined"
                size="small"
                className={classes.expandButton}
                onClick={collapseAll}
              >
                <RemoveIcon fontSize="small" />
              </Button>
            </Tooltip>
            <Tooltip
              title={<span className={classes.tooltip}>Rozbalit úroveň</span>}
              placement="top"
            >
              <Button
                onClick={() => expandNext(eadId!)}
                variant="outlined"
                //disabled={(nextIdsToExpand?.length ?? 0) === 0}
                className={classes.expandButton}
                size="small"
              >
                <AddIcon fontSize="small" />
              </Button>
            </Tooltip>
          </div>
        )}
      </AutoSizer>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip
          title={<span className={classes.tooltip}>Předchozí záznam</span>}
          placement="top"
        >
          <Button
            size="small"
            variant="outlined"
            className={classes.expandButton}
            disabled={currentIndex === 0}
            onClick={() => {
              if (currentIndex === 0) {
                return;
              }
              push(
                `${rootUrl}/${getRootId?.()}/ead/${
                  flatEad[currentIndex - 1]?.id
                }`
              );
            }}
          >
            <NavigateBeforeIcon fontSize="small" />
          </Button>
        </Tooltip>
        <Tooltip
          title={<span className={classes.tooltip}>Další záznam</span>}
          placement="top"
        >
          <Button
            size="small"
            variant="outlined"
            className={classes.expandButton}
            disabled={currentIndex === flatEad?.length - 1}
            onClick={() => {
              if (currentIndex === flatEad?.length - 1) {
                return;
              }
              push(
                `${rootUrl}/${getRootId?.()}/ead/${
                  flatEad[currentIndex + 1]?.id
                }`
              );
            }}
          >
            <NavigateNextIcon fontSize="small" />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
export default ControlButtons;
